import { getFullName } from "@/core/services/base/GlobalFunctios";
import { eRolAppUsuario } from "../GloblasEnum";
import { IEmployee } from "../sys/IEmployee";
import { ICustomer } from "../sys/ICustomer";

export interface ISesionApp
{
    Gid:string;
    Type:number;    
    Token:string;
    Employee:IEmployee|null;
    Cliente:ICustomer|null;    
    Active:boolean;    
    canAccess():boolean;
    getId():string;
    FullName:string;
}
export class SesionApp implements ISesionApp
{
    constructor(data?: any)
    {
        Object.assign(this, data);        
    }
    public Gid="";
    public Token="";
    public Type = 0;
    public Employee: IEmployee|null = null;
    public Cliente:ICustomer|null = null;    
    public Active = false;    
    public canAccess():boolean
    {
     return this.Active && (this.Employee || this.Cliente) ? true: false;
    }
    public getId():string
    {
        if(this.Type === eRolAppUsuario.Empleado && this.Employee)
        {                        
            return this.Employee.Gid;
        }
        if(this.Type === eRolAppUsuario.Cliente && this.Cliente)
        {
            return this.Cliente.Gid;
        }
        return "";
    }
    public get FullName():string
    {
        if(this.Type === eRolAppUsuario.Empleado && this.Employee)
        {                 
            return getFullName(this.Employee);
        }
        if(this.Type === eRolAppUsuario.Cliente && this.Cliente)
        {
            return getFullName(this.Cliente);            
        }
        return "";
    }
}